// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');

    this.swiperOptions = {
      direction: 'horizontal'
    }

    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });
    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false
    });
  }
}

if(!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}

class productInfo extends HTMLElement {

  constructor() {
    super();
    this.productForm = this.querySelector('product-form');
    this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
    this.quantityInput = this.querySelector('quantity-input');
    this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
    this.quantityInputElement?.addEventListener('change', () => {
      this.handleQuantityInput();
    });

    // show variant inventory quantity warning
    const inventoryVariantSelected = document.querySelector('[data-inventory-variant-selected]') || false;
    const inventoryVariantHover = document.querySelector('[data-inventory-variant-hover]') || false;
    const optionsLabels = document.querySelectorAll('.js-options-label') || false;

    optionsLabels.forEach((optionLabel) => {

      optionLabel.addEventListener('mouseover', (e) => {
        const value = e.target.dataset.inventoryQuantity;
        if (inventoryVariantHover) {
          inventoryVariantHover.innerHTML = value;
        }
        if (inventoryVariantSelected) {
          inventoryVariantSelected.style.display = 'none';
        }

      });

      optionLabel.addEventListener('mouseout', (e) => {
        if (inventoryVariantHover) {
          inventoryVariantHover.innerHTML = '';
        }
        if (inventoryVariantSelected) {
          inventoryVariantSelected.style.display = 'block';
        }

      });

      optionLabel.addEventListener('click', (e) => {
        const value = e.target.dataset.inventoryQuantity;
        if (inventoryVariantSelected) {
          inventoryVariantSelected.innerHTML = value;
        }

      });

    });


    // watch the add to cart button with an observer
    const watch = document.querySelector('.js-product-form');
    const body = document.querySelector('body');

    function cloneElement(el, elWrapper) {

      if (el.classList.contains('clone')) {
        return;
      }

      // clone the element and append the element
      if(typeof(el) != undefined && el != null && typeof(elWrapper) != undefined && elWrapper != null) {
        el.classList.add('clone');
        const clone = el.cloneNode(true);
        elWrapper.appendChild(clone);
      }
    }

    function obCallback(payload) {

      // Check if user has scrolled past the main ATC element
      const addToCartElement = body.querySelector('[data-main-add-to-cart-wrapper] button[type="submit"]');
      const hasScrolledPastAddToCart = addToCartElement?.getBoundingClientRect().bottom < 0;

      // if add to cart button is off the screen and the user has scrolled past the main ATC element
      if (payload[0].isIntersecting === false && payload[0].intersectionRatio === 0 && hasScrolledPastAddToCart) {

        // add sticky class to body
        body.classList.add('product-add-to-cart--sticky');

        // clone product form
        const productForm = document.querySelector('.js-product-form');
        const productFormWrapper = document.querySelector('.js-product-form-target');

          // clone the element and append the element
        if(typeof(productForm) != undefined && productForm != null && typeof(productFormWrapper) != undefined && productFormWrapper != null) {
          cloneElement(productForm, productFormWrapper);
        }

        setTimeout(() => {
          body.classList.add('show');
        }, 500);

      // if add to cart button is on the screen
      }
      else {

        // remove sticky class from body
        body.classList.remove('product-add-to-cart--sticky');

        const variantDropdown = document.querySelector('.custom-select__list');
        if (typeof(variantDropdown) != undefined && variantDropdown != null ) {
          variantDropdown.classList.remove('is-open');
        }

        setTimeout(() => {
          body.classList.remove('show');
        }, 500);

      }
    }

    // observe
    const ob = new IntersectionObserver(obCallback);
    ob.observe(watch);
  }

  /**
   * handleQuantityInput
   * @description Set the quantity from the quantity input web component to the product form web component.
   */
  handleQuantityInput() {
    this.productFormQuantity.value = this.quantityInputElement.value;
  }
}

if(!customElements.get('product-info')) {
  customElements.define('product-info', productInfo);
}

class pdpBreadcrumbs extends HTMLElement {
  constructor() {
    super();

    /*
      Displaying the correct order of the breadcrumbs
      If a collection has multiple parents in the main menu, it doesn't show the right breadcrumb path.
      Therefore we get the right path with js and we get it from sessionStorage.
    */

    // get breadcrumbs from session storage
    const breadcrumbsFromStorage = sessionStorage.getItem('breadcrumbs');
    const breadcrumbsWrapper = this.querySelector('[data-breadcrumbs-wrapper]');

    // render breadcrumbs html
    const breadcrumbsinnerHtml = this.generateBreadcrumbsItems(breadcrumbsFromStorage);
    if (breadcrumbsinnerHtml) {
      breadcrumbsWrapper.innerHTML = breadcrumbsinnerHtml;
    }

    // reset breadcrumbs storage
    setTimeout(() => {
      sessionStorage.removeItem('breadcrumbs');
    }, 100);

  }

  generateBreadcrumbsItems(breadcrumbsdata) {
    if (breadcrumbsdata == undefined || breadcrumbsdata == null || breadcrumbsdata == '' ) {
      return false;
    }

    let breadcrumbsList = '';
    const breadcrumbsArr = breadcrumbsdata.split('::');
    breadcrumbsArr.forEach((item, index) => {
      const itemArr = item.split('|');
      const itemTitle = itemArr[0];
      const itemUrl = itemArr[1];
      breadcrumbsList +=`
        <li class="breadcrumbs__item" itemprop="itemListElement" itemscope="" itemtype="https://schema.org/ListItem">
          <a class="breadcrumbs__link" itemprop="item" href="${itemUrl}">
            <span itemprop="name">${itemTitle}</span>
          </a>
          <meta itemprop="position" content="${index + 1}">
        </li>
      `;
    });

    return breadcrumbsList;

  }
}

if(!customElements.get('pdp-breadcrumbs')) {
  customElements.define('pdp-breadcrumbs', pdpBreadcrumbs);
}
